import FeedbackButton from './components/FeedbackButton';
import FeedbackCollector from './components/FeedbackCollector';
import FeedbackFlag from './components/FeedbackFlag';
import FeedbackForm from './components/FeedbackForm';
export type { FormFields } from './types';

export default FeedbackCollector;
export { FeedbackFlag, FeedbackForm, FeedbackButton };
